export default class Core6Carousel {
  constructor(carouselId) {
    this.itemWidth = 80;
    this.minMargin = 10;
    this.carouselContainer = $(`.coreCarouselMulti[data-component-id=${carouselId}]`);
    this.carouselContainerContent = $(`.coreCarouselMulti[data-component-id=${carouselId}] .coreCarouselMultiContent`);
    this.carouselContainerContentSliderPanel = $(`.coreCarouselMulti[data-component-id=${carouselId}] .coreCarouselMultiContentSliderPanel`);
    this.carouselContainerContentSliderPanelItems = $(`.coreCarouselMulti[data-component-id=${carouselId}] .coreCarouselMultiContentSliderPanel>.item`);
    this.carouselNextButton = $(`.coreCarouselMulti[data-component-id=${carouselId}] .core6CarouselControl.right`);
    this.carouselPrevButton = $(`.coreCarouselMulti[data-component-id=${carouselId}] .core6CarouselControl.left`);

    this.initialise();
  }

  initialise() {
    this.setSpacing();
    this.setCarouselPanelSize();
    this.addPrevButtonEventHandler();
    this.addNextButtonEventHandler();
  }

  setSpacing() {
    const contentWidth = this.carouselContainerContent.width();
    const minItemWidth = this.itemWidth + (this.minMargin * 2);
    const perPanel = contentWidth / minItemWidth;
    const itemsPerPanel = Math.floor(perPanel);
    const allItemsWidth = itemsPerPanel * this.itemWidth;
    const allMarginsWidth = contentWidth - allItemsWidth;
    const perItemMargins = allMarginsWidth / itemsPerPanel;
    const perSideMarginWidth = perItemMargins / 2;
    console.log(perItemMargins * itemsPerPanel);
    this.minMargin = perSideMarginWidth;
  }

  setCarouselPanelSize() {
    const itemCount = this.carouselContainerContentSliderPanelItems.length;
    this.carouselContainerContentSliderPanelItems.css('width', `${this.itemWidth}px`);
    this.carouselContainerContentSliderPanelItems.css('margin-left', `${this.minMargin}px`);
    this.carouselContainerContentSliderPanelItems.css('margin-right', `${this.minMargin}px`);
    this.carouselContainerContentSliderPanel.width(itemCount * (this.itemWidth + (this.minMargin * 2)));
  }

  addPrevButtonEventHandler() {
    this.carouselPrevButton.on('click', () => {
      Core6Carousel.prevListener(this.carouselContainerContentSliderPanel, this.carouselContainerContent);
    });
  }

  static prevListener(carouselContainerContentSliderPanel, carouselContainerContent) {
    console.log('prev clicked');
    let newPos = carouselContainerContentSliderPanel.position().left;
    newPos += carouselContainerContent.width();
    if (newPos > 0) {
      newPos = 0;
    }
    carouselContainerContentSliderPanel.animate({ left: `${newPos}px` }, 400);
  }

  addNextButtonEventHandler() {
    this.carouselNextButton.on('click', () => Core6Carousel.nextListener(this.carouselContainerContent, this.carouselContainerContentSliderPanel));
  }

  static nextListener(carouselContainerContent, carouselContainerContentSliderPanel) {
    console.log('next clicked');
    let newPos = carouselContainerContentSliderPanel.position().left;
    if ((newPos - carouselContainerContent.width()) * -1 < carouselContainerContentSliderPanel.width()) {
      newPos -= carouselContainerContent.width();
    }
    carouselContainerContentSliderPanel.animate({ left: `${newPos}px` }, 400);
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/core6/Core6Carousel.js